export default __webpack_public_path__ + "static/media/fb.994e06ee.svg";